import React, { useState, useEffect } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import MainLayout from '../../components/MainLayout';
import './CompanyDetail.css';

function CompanyDetail() {
  const navigate = useNavigate();
  const { companyId } = useParams();
  const [searchParams] = useSearchParams();
  const [isEditing, setIsEditing] = useState(false);

  // URL 쿼리 파라미터에서 edit 모드 확인
  useEffect(() => {
    const editMode = searchParams.get('edit');
    if (editMode === 'true') {
      setIsEditing(true);
    } else {
      setIsEditing(false);
    }
  }, [searchParams]);

  // TODO: API에서 회사 데이터 가져오기
  const [formData, setFormData] = useState({
    id: companyId,
    name: 'aaa',
    code: 'aaa',
    ceo: '김대표',
    businessNumber: '124-81-00998',
    address: '서울특별시 영등포구',
    phone: '031-200-1114',
    employees: 120,
    status: '활성',
    createdDate: '2020-01-15'
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleEdit = () => {
    // URL에 ?edit=true 쿼리 파라미터 추가
    navigate(`/admin/company/${companyId}?edit=true`, { replace: true });
  };

  const handleCancel = () => {
    if (isEditing) {
      // URL에서 ?edit=true 제거
      navigate(`/admin/company/${companyId}`, { replace: true });
      // TODO: 원래 데이터로 복원
    } else {
      navigate('/admin');
    }
  };

  const handleSave = (e) => {
    e.preventDefault();
    // TODO: 회사 정보 업데이트 API 호출
    
    // 저장 후 읽기 모드로 전환 (URL도 변경)
    navigate(`/admin/company/${companyId}`, { replace: true });
  };

  const handleDelete = () => {
    if (window.confirm('정말로 이 회사를 삭제하시겠습니까?')) {
      // TODO: 회사 삭제 API 호출
      
      navigate('/admin');
    }
  };

  return (
    <MainLayout>
      <div className="company-detail-container">
        {/* Header Section */}
        <div className="company-detail-header">
          <div className="company-detail-header-left">
            <div className="back-btn" onClick={() => navigate('/admin')}>
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                <path d="M12.5 15L7.5 10L12.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div>
              <div className="company-detail-title">회사 상세 정보</div>
              <p className="company-detail-subtitle">회사 정보 조회 및 수정</p>
            </div>
          </div>
          <div className="company-detail-header-right">
            {!isEditing ? (
              <>
                <button className="delete-header-btn" onClick={handleDelete}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M2 4H3.33333H14M5.33333 4V2.66667C5.33333 2.31305 5.47381 1.97391 5.72386 1.72386C5.97391 1.47381 6.31305 1.33333 6.66667 1.33333H9.33333C9.68696 1.33333 10.0261 1.47381 10.2761 1.72386C10.5262 1.97391 10.6667 2.31305 10.6667 2.66667V4M12.6667 4V13.3333C12.6667 13.687 12.5262 14.0261 12.2761 14.2761C12.0261 14.5262 11.687 14.6667 11.3333 14.6667H4.66667C4.31305 14.6667 3.97391 14.5262 3.72386 14.2761C3.47381 14.0261 3.33333 13.687 3.33333 13.3333V4H12.6667Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  삭제
                </button>
                <button className="edit-header-btn" onClick={handleEdit}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M11.3333 2C11.5084 1.82493 11.7163 1.68605 11.9457 1.59135C12.1752 1.49665 12.4218 1.44803 12.6707 1.44803C12.9196 1.44803 13.1662 1.49665 13.3956 1.59135C13.6251 1.68605 13.833 1.82493 14.008 2C14.183 2.17507 14.3219 2.38299 14.4166 2.61245C14.5113 2.84191 14.5599 3.08852 14.5599 3.33744C14.5599 3.58636 14.5113 3.83297 14.4166 4.06243C14.3219 4.29189 14.183 4.49981 14.008 4.67488L5.33333 13.3495L1.33333 14.683L2.66667 10.6829L11.3333 2Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  수정
                </button>
              </>
            ) : (
              <>
                <button className="cancel-btn" onClick={handleCancel}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M12 4L4 12M4 4L12 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  취소
                </button>
                <button className="save-btn" onClick={handleSave}>
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                  </svg>
                  저장
                </button>
              </>
            )}
          </div>
        </div>

        {/* Content Section */}
        <div className="company-detail-content">
          {/* Company Profile Card */}
          <div className="company-profile-card">
            <div className="company-profile-icon">
              <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                <path d="M8 40V12C8 10.9391 8.42143 9.92172 9.17157 9.17157C9.92172 8.42143 10.9391 8 12 8H36C37.0609 8 38.0783 8.42143 38.8284 9.17157C39.5786 9.92172 40 10.9391 40 12V40M8 40H4M8 40H18M40 40H44M40 40H30M18 40V32C18 30.9391 18.4214 29.9217 19.1716 29.1716C19.9217 28.4214 20.9391 28 22 28H26C27.0609 28 28.0783 28.4214 28.8284 29.1716C29.5786 29.9217 30 30.9391 30 32V40M18 40H30M16 16H18M16 24H18M24 16H26M24 24H26M32 16H34M32 24H34" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
            <div className="company-profile-info">
              <h2 className="company-profile-name">{formData.name}</h2>
              <p className="company-profile-code">회사코드: {formData.code}</p>
              <span className={`status-badge-large ${formData.status === '활성' ? 'status-active' : 'status-inactive'}`}>
                {formData.status}
              </span>
            </div>
            <div className="company-profile-meta">
              <div className="meta-item">
                <span className="meta-label">등록일</span>
                <span className="meta-value">{formData.createdDate}</span>
              </div>
              <div className="meta-item">
                <span className="meta-label">직원수</span>
                <span className="meta-value">{formData.employees.toLocaleString()}명</span>
              </div>
            </div>
          </div>

          {/* Detail Form */}
          <form onSubmit={handleSave}>
            {/* 기본 정보 섹션 */}
            <div className="detail-section">
              <h3 className="section-title">기본 정보</h3>
              <div className="detail-grid">
                <div className="detail-group">
                  <label className="detail-label">회사명</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="name"
                      className="detail-input"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                    />
                  ) : (
                    <div className="detail-value">{formData.name}</div>
                  )}
                </div>

                <div className="detail-group">
                  <label className="detail-label">회사코드</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="code"
                      className="detail-input"
                      value={formData.code}
                      onChange={handleInputChange}
                      required
                    />
                  ) : (
                    <div className="detail-value">{formData.code}</div>
                  )}
                </div>

                <div className="detail-group">
                  <label className="detail-label">대표이사</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="ceo"
                      className="detail-input"
                      value={formData.ceo}
                      onChange={handleInputChange}
                      required
                    />
                  ) : (
                    <div className="detail-value">{formData.ceo}</div>
                  )}
                </div>

                <div className="detail-group">
                  <label className="detail-label">사업자번호</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="businessNumber"
                      className="detail-input"
                      value={formData.businessNumber}
                      onChange={handleInputChange}
                      placeholder="123-81-00998"
                      required
                    />
                  ) : (
                    <div className="detail-value">{formData.businessNumber}</div>
                  )}
                </div>
              </div>
            </div>

            {/* 연락 정보 섹션 */}
            <div className="detail-section">
              <h3 className="section-title">연락 정보</h3>
              <div className="detail-grid">
                <div className="detail-group detail-group-full">
                  <label className="detail-label">주소</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="address"
                      className="detail-input"
                      value={formData.address}
                      onChange={handleInputChange}
                      required
                    />
                  ) : (
                    <div className="detail-value">{formData.address}</div>
                  )}
                </div>

                <div className="detail-group">
                  <label className="detail-label">연락처</label>
                  {isEditing ? (
                    <input
                      type="text"
                      name="phone"
                      className="detail-input"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="031-200-1114"
                      required
                    />
                  ) : (
                    <div className="detail-value">{formData.phone}</div>
                  )}
                </div>
              </div>
            </div>

            {/* 운영 정보 섹션 */}
            <div className="detail-section">
              <h3 className="section-title">운영 정보</h3>
              <div className="detail-grid">
                <div className="detail-group">
                  <label className="detail-label">직원수</label>
                  {isEditing ? (
                    <input
                      type="number"
                      name="employees"
                      className="detail-input"
                      value={formData.employees}
                      onChange={handleInputChange}
                      min="1"
                      required
                    />
                  ) : (
                    <div className="detail-value">{formData.employees.toLocaleString()}명</div>
                  )}
                </div>

                <div className="detail-group">
                  <label className="detail-label">상태</label>
                  {isEditing ? (
                    <div className="dropdown-container">
                      <select
                        name="status"
                        className="detail-select"
                        value={formData.status}
                        onChange={handleInputChange}
                        required
                      >
                        <option value="활성">활성</option>
                        <option value="비활성">비활성</option>
                      </select>
                      <svg className="dropdown-icon" width="12" height="12" viewBox="0 0 12 12" fill="none">
                        <path d="M2 4L6 8L10 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  ) : (
                    <div className="detail-value">{formData.status}</div>
                  )}
                </div>

                <div className="detail-group">
                  <label className="detail-label">등록일</label>
                  <div className="detail-value">{formData.createdDate}</div>
                </div>
              </div>
            </div>

            {/* Form Actions */}
            {isEditing && (
              <div className="form-actions">
                <button type="button" className="btn-secondary" onClick={handleCancel}>
                  취소
                </button>
                <button type="submit" className="btn-primary">
                  저장
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </MainLayout>
  );
}

export default CompanyDetail;
